"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNotificationsBodyToJSON = exports.UpdateNotificationsBodyFromJSONTyped = exports.UpdateNotificationsBodyFromJSON = void 0;
function UpdateNotificationsBodyFromJSON(json) {
    return UpdateNotificationsBodyFromJSONTyped(json, false);
}
exports.UpdateNotificationsBodyFromJSON = UpdateNotificationsBodyFromJSON;
function UpdateNotificationsBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'notificationMarketing': json['notificationMarketing'],
        'notificationMenuOrderStatus': json['notificationMenuOrderStatus'],
    };
}
exports.UpdateNotificationsBodyFromJSONTyped = UpdateNotificationsBodyFromJSONTyped;
function UpdateNotificationsBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'notificationMarketing': value.notificationMarketing,
        'notificationMenuOrderStatus': value.notificationMenuOrderStatus,
    };
}
exports.UpdateNotificationsBodyToJSON = UpdateNotificationsBodyToJSON;
